import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/icon/location-yellow.png'


const _hoisted_1 = { id: "customer-retail" }
const _hoisted_2 = { class: "mr-3 font-normal" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h6", { class: "font-normal" }, "Informasi Pelanggan", -1)
const _hoisted_4 = { class: "grid lg:grid-cols-2 grid-cols-1 gap-5" }
const _hoisted_5 = { class: "w-full px-5" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = {
  key: 0,
  class: "p-error"
}
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = {
  key: 0,
  class: "p-error"
}
const _hoisted_10 = {
  key: 0,
  class: "p-error"
}
const _hoisted_11 = {
  key: 0,
  class: "p-error"
}
const _hoisted_12 = { class: "mb-4" }
const _hoisted_13 = {
  key: 0,
  class: "p-error"
}
const _hoisted_14 = {
  key: 0,
  class: "mb-4 p-col-12"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("label", {
  for: "tiktok",
  class: "text-body2"
}, "Tiktok", -1)
const _hoisted_16 = { class: "w-full px-5" }
const _hoisted_17 = {
  key: 0,
  class: "mb-4 p-col-12"
}
const _hoisted_18 = {
  key: 0,
  class: "p-error"
}
const _hoisted_19 = {
  key: 0,
  class: "p-error"
}
const _hoisted_20 = {
  key: 0,
  class: "p-error"
}
const _hoisted_21 = {
  key: 0,
  class: "p-error"
}
const _hoisted_22 = {
  key: 1,
  class: "mb-4 p-col-12"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("label", {
  for: "email",
  class: "text-body2"
}, "Email", -1)
const _hoisted_24 = {
  key: 2,
  class: "mb-4 p-col-12"
}
const _hoisted_25 = /*#__PURE__*/_createVNode("label", {
  for: "facebook",
  class: "text-body2"
}, "Facebook", -1)
const _hoisted_26 = {
  key: 3,
  class: "mb-4 p-col-12"
}
const _hoisted_27 = /*#__PURE__*/_createVNode("label", {
  for: "instagram",
  class: "text-body2"
}, "Instagram", -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("h6", { class: "font-normal" }, "Voucher", -1)
const _hoisted_29 = { class: "grid lg:grid-cols-2 grid-cols-1 gap-5" }
const _hoisted_30 = { class: "w-full px-5" }
const _hoisted_31 = /*#__PURE__*/_createVNode("h6", { class: "font-normal" }, "Alamat Pelanggan", -1)
const _hoisted_32 = { class: "mx-5" }
const _hoisted_33 = { class: "text-body2 font-semibold" }
const _hoisted_34 = { class: "text-body2 font-semibold" }
const _hoisted_35 = { class: "text-body2 font-semibold color-primary" }
const _hoisted_36 = {
  key: 1,
  class: "p-field mt-4"
}
const _hoisted_37 = /*#__PURE__*/_createVNode("label", {
  for: "idActive",
  class: "text-body2"
}, "Aktif", -1)
const _hoisted_38 = { class: "flex action-button py-5" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Simpan")
const _hoisted_40 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_41 = {
  class: "flex w-full justify-between items-center px-2 pb-5",
  style: {"border-bottom":"1px solid #CFD8DC"}
}
const _hoisted_42 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("h6", { class: "font-semibold text-xl text-black" }, "Alamat Pelanggan")
], -1)
const _hoisted_43 = { class: "flex items-center mb-1" }
const _hoisted_44 = {
  key: 0,
  src: _imports_0,
  class: "w-5 h-5 mr-2",
  alt: "primary"
}
const _hoisted_45 = { class: "text-body2 font-semibold" }
const _hoisted_46 = { class: "text-body2 font-semibold" }
const _hoisted_47 = { class: "text-body2 font-semibold color-primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Card = _resolveComponent("Card")
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("form", {
      onSubmit: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.submitData(!_ctx.v$.$invalid)), ["prevent"]))
    }, [
      _createVNode(_component_Card, { class: "user-edit w-full" }, {
        title: _withCtx(() => [
          _createVNode("h5", _hoisted_2, _toDisplayString(_ctx.title), 1)
        ]),
        content: _withCtx(() => [
          _createVNode(_component_Card, { class: "card-no-shadow mt-3" }, {
            title: _withCtx(() => [
              _hoisted_3
            ]),
            content: _withCtx(() => [
              _createVNode("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  _createVNode("div", _hoisted_6, [
                    _createVNode("label", {
                      for: "namaPelanggan",
                      class: {
                        'p-error': _ctx.v$.namaPelanggan.$invalid && _ctx.submitted,
                        'text-body2': true
                      }
                    }, _toDisplayString(_ctx.formLabel.nama), 3),
                    _createVNode(_component_InputText, {
                      maxlength: "150",
                      id: "namaPelanggan",
                      class: "input-primary mt-1 w-full",
                      name: "namaPelanggan",
                      modelValue: _ctx.v$.namaPelanggan.$model,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.namaPelanggan.$model = $event)),
                      type: "text"
                    }, null, 8, ["modelValue"]),
                    (
                        (_ctx.v$.namaPelanggan.$invalid && _ctx.submitted) ||
                          _ctx.v$.namaPelanggan.$pending.$response
                      )
                      ? (_openBlock(), _createBlock("small", _hoisted_7, _toDisplayString(_ctx.v$.namaPelanggan.required.$message), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_8, [
                    _createVNode("label", {
                      for: "noTelp",
                      class: { 'p-error': _ctx.v$.telepon.$invalid && _ctx.submitted, 'text-body2': true }
                    }, _toDisplayString(_ctx.formLabel.noTelp), 3),
                    _createVNode(_component_InputText, {
                      maxlength: "14",
                      id: "noTelp",
                      class: "input-primary mt-1 w-full",
                      name: "noTelp",
                      modelValue: _ctx.v$.telepon.$model,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.telepon.$model = $event)),
                      type: "number"
                    }, null, 8, ["modelValue"]),
                    _createVNode("p", null, [
                      (_ctx.v$.telepon.required.$invalid && _ctx.submitted)
                        ? (_openBlock(), _createBlock("small", _hoisted_9, _toDisplayString(_ctx.v$.telepon.required.$message), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("p", null, [
                      (_ctx.v$.telepon.maxLength.$invalid && _ctx.submitted)
                        ? (_openBlock(), _createBlock("small", _hoisted_10, _toDisplayString(_ctx.v$.telepon.maxLength.$message), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("p", null, [
                      (_ctx.v$.telepon.firstNumber.$invalid && _ctx.submitted)
                        ? (_openBlock(), _createBlock("small", _hoisted_11, _toDisplayString(_ctx.v$.telepon.firstNumber.$message), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("div", _hoisted_12, [
                    _createVNode("label", {
                      for: "username",
                      class: {
                        'p-error': _ctx.v$.username.$invalid && _ctx.submitted,
                        'text-body2': true
                      }
                    }, _toDisplayString(_ctx.formLabel.username), 3),
                    _createVNode(_component_InputText, {
                      maxlength: "150",
                      id: "username",
                      class: "input-primary mt-1 w-full",
                      name: "username",
                      modelValue: _ctx.v$.username.$model,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.username.$model = $event)),
                      type: "text",
                      disabled: "true"
                    }, null, 8, ["modelValue"]),
                    (
                        (_ctx.v$.username.$invalid && _ctx.submitted) ||
                          _ctx.v$.username.$pending.$response
                      )
                      ? (_openBlock(), _createBlock("small", _hoisted_13, _toDisplayString(_ctx.v$.username.required.$message), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.checkRetailOrCompany())
                    ? (_openBlock(), _createBlock("div", _hoisted_14, [
                        _hoisted_15,
                        _createVNode(_component_InputText, {
                          maxlength: "50",
                          id: "tiktok",
                          class: "input-primary mt-1 w-full",
                          name: "tiktok",
                          modelValue: _ctx.dataForm.tiktok,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.dataForm.tiktok = $event)),
                          type: "text"
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_16, [
                  (_ctx.checkRetailOrCompany())
                    ? (_openBlock(), _createBlock("div", _hoisted_17, [
                        _createVNode("label", {
                          for: "noKTP",
                          class: { 'p-error': _ctx.v$.noKtp.$invalid && _ctx.submitted, 'text-body2': true }
                        }, "No. KTP", 2),
                        _createVNode(_component_InputText, {
                          maxlength: "16",
                          id: "noKTP",
                          class: "input-primary mt-1 w-full",
                          name: "noKTP",
                          modelValue: _ctx.v$.noKtp.$model,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.noKtp.$model = $event)),
                          type: "number"
                        }, null, 8, ["modelValue"]),
                        _createVNode("p", null, [
                          (_ctx.v$.noKtp.required.$invalid && _ctx.submitted)
                            ? (_openBlock(), _createBlock("small", _hoisted_18, _toDisplayString(_ctx.v$.noKtp.required.$message), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("p", null, [
                          (_ctx.v$.noKtp.numeric.$invalid && _ctx.submitted)
                            ? (_openBlock(), _createBlock("small", _hoisted_19, _toDisplayString(_ctx.v$.noKtp.numeric.$message), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("p", null, [
                          (_ctx.v$.noKtp.minLength.$invalid && _ctx.submitted)
                            ? (_openBlock(), _createBlock("small", _hoisted_20, _toDisplayString(_ctx.v$.noKtp.minLength.$message), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("p", null, [
                          (_ctx.v$.noKtp.maxLength.$invalid && _ctx.submitted)
                            ? (_openBlock(), _createBlock("small", _hoisted_21, _toDisplayString(_ctx.v$.noKtp.maxLength.$message), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.checkRetailOrCompany())
                    ? (_openBlock(), _createBlock("div", _hoisted_22, [
                        _hoisted_23,
                        _createVNode(_component_InputText, {
                          maxlength: "50",
                          id: "email",
                          class: "input-primary mt-1 w-full",
                          name: "email",
                          modelValue: _ctx.dataForm.email,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.dataForm.email = $event)),
                          type: "email"
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.checkRetailOrCompany())
                    ? (_openBlock(), _createBlock("div", _hoisted_24, [
                        _hoisted_25,
                        _createVNode(_component_InputText, {
                          maxlength: "50",
                          id: "facebook",
                          class: "input-primary mt-1 w-full",
                          name: "facebook",
                          modelValue: _ctx.dataForm.fb,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.dataForm.fb = $event)),
                          type: "text"
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.checkRetailOrCompany())
                    ? (_openBlock(), _createBlock("div", _hoisted_26, [
                        _hoisted_27,
                        _createVNode(_component_InputText, {
                          maxlength: "50",
                          id: "instagram",
                          class: "input-primary mt-1 w-full",
                          name: "instagram",
                          modelValue: _ctx.dataForm.ig,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.dataForm.ig = $event)),
                          type: "text"
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }),
          (_ctx.dataForm.userLevelId === 1)
            ? (_openBlock(), _createBlock(_component_Card, {
                key: 0,
                class: "card-no-shadow mt-5"
              }, {
                title: _withCtx(() => [
                  _hoisted_28
                ]),
                content: _withCtx(() => [
                  _createVNode("div", _hoisted_29, [
                    _createVNode("div", _hoisted_30, [
                      _createVNode(_component_Multiselect, {
                        class: "input-primary w-full rounded-lg",
                        modelValue: _ctx.voucherCodeId,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.voucherCodeId = $event)),
                        placeholder: "Pilih Voucher",
                        options: _ctx.voucherOption,
                        searchable: true,
                        multiple: true,
                        "close-on-select": false,
                        "clear-on-select": false,
                        mode: "tags",
                        label: "label",
                        "track-by": "label",
                        taggable: true,
                        onDeselect: _ctx.tagging
                      }, null, 8, ["modelValue", "options", "onDeselect"])
                    ])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_Card, { class: "card-no-shadow mt-5" }, {
            title: _withCtx(() => [
              _hoisted_31
            ]),
            content: _withCtx(() => [
              _createVNode("div", _hoisted_32, [
                _createVNode("p", _hoisted_33, _toDisplayString(_ctx.dataForm.alias), 1),
                _createVNode(_component_Card, { class: "card-no-shadow" }, {
                  content: _withCtx(() => [
                    _createVNode("p", _hoisted_34, _toDisplayString(_ctx.dataForm.namaPenerima) + " - " + _toDisplayString(_ctx.dataForm.telpPenerima), 1),
                    _createVNode("p", _hoisted_35, _toDisplayString(_ctx.dataForm.alamat), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            footer: _withCtx(() => [
              _createVNode("p", {
                class: "text-body2 font-normal color-primary cursor-pointer",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showAlamatDialog(_ctx.customerId)))
              }, "Lihat Semua Alamat")
            ]),
            _: 1
          }),
          (_ctx.Id)
            ? (_openBlock(), _createBlock("div", _hoisted_36, [
                _hoisted_37,
                _createVNode("div", null, [
                  _createVNode(_component_InputSwitch, {
                    id: "idActive",
                    class: "switch-og mt-1",
                    modelValue: _ctx.dataForm.isActive,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.dataForm.isActive = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_38, [
            _createVNode(_component_Button, {
              class: "btn-primary text-black mr-3 px-5 py-1 w-auto",
              type: "submit"
            }, {
              default: _withCtx(() => [
                _hoisted_39
              ]),
              _: 1
            }),
            _createVNode(_component_Button, {
              class: "btn-secondary text-black px-5 py-1 w-auto",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.redirectBack()))
            }, {
              default: _withCtx(() => [
                _hoisted_40
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ], 32),
    _createVNode(_component_Dialog, {
      visible: _ctx.isShowAlamatDialog,
      "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => (_ctx.isShowAlamatDialog = $event)),
      class: "dialog-voucher",
      modal: true,
      dismissableMask: true
    }, {
      header: _withCtx(() => [
        _createVNode("div", _hoisted_41, [
          _hoisted_42,
          _createVNode("i", {
            class: "pi pi-times text-black cursor-pointer",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.closeAlamatDialog()))
          })
        ])
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.userAddresses, (item, index) => {
          return (_openBlock(), _createBlock("div", {
            class: "mx-5",
            key: index
          }, [
            _createVNode("div", _hoisted_43, [
              (item.IsPrimary)
                ? (_openBlock(), _createBlock("img", _hoisted_44))
                : _createCommentVNode("", true),
              _createVNode("span", _hoisted_45, _toDisplayString(item.Alias), 1)
            ]),
            _createVNode(_component_Card, {
              class: "card-no-shadow",
              id: "userAddresses"
            }, {
              content: _withCtx(() => [
                _createVNode("p", _hoisted_46, _toDisplayString(item.NamaPenerima) + " - " + _toDisplayString(item.HpPenerima), 1),
                _createVNode("p", _hoisted_47, _toDisplayString(item.Alamat1), 1)
              ]),
              _: 2
            }, 1024)
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}